import Model, { attr, hasMany, belongsTo } from '@ember-data/model';
import { sort, alias } from '@ember/object/computed';

export default class PlaylistModel extends Model {
  @attr('string') name;
  @attr projectIds;
  @attr teamId;

  @belongsTo('team', { inverse: null, async: false }) owningTeam;
  @belongsTo('user', { inverse: null, async: false }) user;

  @hasMany('playlist-entry', { inverse: null, async: false }) playlistEntries;

  @hasMany('team-playlist', { inverse: 'playlist', async: false })
  teamPlaylists;

  createdAtSorting = ['createdAt:asc'];
  @sort('comments', 'createdAtSorting') sortedComments;

  entrySorting = ['order:asc'];
  @sort('playlistEntries', 'entrySorting') sortedPlaylistEntries;

  setProjectIds() {
    if (this.projectIds) {
      return;
    }
    let ids = [];
    for (let i = 0, len = this.playlistEntries.length; i < len; i++) {
      let entry = this.playlistEntries[i];
      ids.push(entry.project.id);
    }
    this.projectIds = ids;
  }
}
